import apiClient from './apiClient';

export const kiZentraleApi = {
  // Gemeinsame Einstellungen
  getSettings: () => apiClient.get('/ki-zentrale/settings').then(r => r.data),
  updateSettings: (settings) => apiClient.put('/ki-zentrale/settings', settings).then(r => r.data),

  // Agent-Status
  getStatus: () => apiClient.get('/ki-zentrale/status').then(r => r.data),

  // KI Todos
  getTodos: (params = {}) => apiClient.get('/ki-zentrale/todos', { params }).then(r => r.data),

  // Unified Timeline
  getTimeline: (params = {}) => apiClient.get('/ki-zentrale/timeline', { params }).then(r => r.data),

  // Branche
  getBranche: () => apiClient.get('/ki-zentrale/branche').then(r => r.data),
  updateBranche: (data) => apiClient.put('/ki-zentrale/branche', data).then(r => r.data),

  // Leistungen
  getLeistungen: () => apiClient.get('/ki-zentrale/leistungen').then(r => r.data),
  updateLeistungen: (data) => apiClient.put('/ki-zentrale/leistungen', data).then(r => r.data),

  // Pflichtfelder
  getPflichtfelder: () => apiClient.get('/ki-zentrale/pflichtfelder').then(r => r.data),
  updatePflichtfelder: (pflichtfelder) => apiClient.put('/ki-zentrale/pflichtfelder', { pflichtfelder }).then(r => r.data),
  resetPflichtfelder: () => apiClient.post('/ki-zentrale/pflichtfelder/reset').then(r => r.data),

  // Anfrage-Themen
  getThemen: () => apiClient.get('/ki-zentrale/themen').then(r => r.data),
  createThema: (data) => apiClient.post('/ki-zentrale/themen', data).then(r => r.data),
  updateThema: (id, data) => apiClient.put(`/ki-zentrale/themen/${id}`, data).then(r => r.data),
  deleteThema: (id) => apiClient.delete(`/ki-zentrale/themen/${id}`).then(r => r.data),
  getThemenPflichtfelder: (themaId) => apiClient.get(`/ki-zentrale/themen/${themaId}/pflichtfelder`).then(r => r.data),
  updateThemenPflichtfelder: (themaId, pflichtfelder) => apiClient.put(`/ki-zentrale/themen/${themaId}/pflichtfelder`, { pflichtfelder }).then(r => r.data),

  // Wissensbasis RAG
  getWissensquellen: () => apiClient.get('/ki-zentrale/wissensbasis').then(r => r.data),
  uploadWissensquelle: (formData) => apiClient.post('/ki-zentrale/wissensbasis/pdf', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data),
  addWissensquelleUrl: (data) => apiClient.post('/ki-zentrale/wissensbasis/url', data).then(r => r.data),
  deleteWissensquelle: (id) => apiClient.delete(`/ki-zentrale/wissensbasis/${id}`).then(r => r.data),
  reprocessWissensquelle: (id) => apiClient.post(`/ki-zentrale/wissensbasis/${id}/reprocess`).then(r => r.data),
  getWissensquelleStatus: (id) => apiClient.get(`/ki-zentrale/wissensbasis/${id}/status`).then(r => r.data),

  // First-Message-Rules (HeyKiki: tageszeit-abhängige Begrüßungen)
  getFirstMessageRules: () => apiClient.get('/ki-zentrale/first-message-rules').then(r => r.data),
  createFirstMessageRule: (data) => apiClient.post('/ki-zentrale/first-message-rules', data).then(r => r.data),
  updateFirstMessageRule: (id, data) => apiClient.put(`/ki-zentrale/first-message-rules/${id}`, data).then(r => r.data),
  deleteFirstMessageRule: (id) => apiClient.delete(`/ki-zentrale/first-message-rules/${id}`).then(r => r.data),
};
